module.exports = __webpack_public_path__ + "static/media/AdLogo.0c41dab7.svg";